<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_013"><img alt="Image" src="images/f0007-01.jpg"/></a></p><a id="file_013">
<p class="image"><img alt="Image" src="images/f0007-02.jpg"/></p>
<p class="caption">Clockwise from upper left: (A) wool combs, (B) metal two-needle holder, (C) wooden skewers for shaping wool, (D) foam, (E) embroidery scissors, (F) sewing needle for adding details, (G) felting needles (see close-up at left), (H) wooden five-needle holder</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_013.vue?972b61d6